import React from "react";
import { Tooltip } from "~/native-ui/Tooltip";
import { SpinnerButton, } from "./SpinnerButton"
import { withResponsiveFlags } from '~/hoc/withResponsiveProps';

export const SaveButton = withResponsiveFlags((props, ref) => (
        <Tooltip key="save" disabled={props.disabled} tooltip={props.label} rightMargin>
            <SpinnerButton
                primary
                disabled={props.disabled}
                icon={props.icon ?? (!props.disabled ? 'save' : 'done-all')}
                iconSize="sm"
                onPress={props.onPress || props.onClick}
                children={props.isXS ? null : props.label }
                ref={ref}
            />
        </Tooltip>
    ),
    { addRef: true, includeKeys: ["isXS"] }
)